import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Translational_Immunol_Academia_Industry_Award = () => {
    return (
        <div>
            <Header/>
            <Navbar/>
            <div className="px-4">
        <div className="max-w-7xl mx-auto bg-white p-6 ">
          {/* Header Section */}
          <header className="flex justify-between items-center mb-2 pb-6">
            <h1 className="text-3xl md:text-4xl text-blue-800 ">I.I.S. Awards</h1>

          </header>

          {/* Content Section */}
          <section>
            <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 ">Translational Immunol & Academia-Industry Award</h2>
            <p className="text-md md:text-lg text-gray-600 mb-4">
            The Prof. & Mrs. Narinder K. Mehra Award for Translational Immunology and Academia-Industry Partnership has been established to recognize Indian Immunologists who are making significant contributions to the vital field of medical innovation on a global scale. This prestigious award is open to all Indian Immunologists who are actively promoting medical innovations that address pressing global health challenges. The recipient of the award will be honored with a citation and a cash prize of One Lakh Rupees (1,00,000). For further details, including eligibility and application procedures, please visit the IIS website at
             <a href="https://www.indianimmunologysociety.org/" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer"> click here</a>.
            </p>
          </section>
        </div>
        <div className="bg-gray-100 mt-6 py-4">
          <div className="max-w-7xl mx-auto px-4 text-center">
            
            <p className="text-base mb-6">
              Nomination Form:
              <a
                href="/nomination_form.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>
            <p className="text-base mb-6">
              Guideline:
              <a
                href="/guidelines.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>

          </div>
        </div>
      </div>
        </div>
    )
}

export default Translational_Immunol_Academia_Industry_Award
